import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const getRoles = (params) => ({
  type: actionTypes.GET_ROLES,
  params
});

export const createRole = (payload) => ({
  type: actionTypes.CREATE_ROLE,
  payload
});

export const updateRole = (payload) => ({
  type: actionTypes.UPDATE_ROLE,
  payload
});

export const deleteRole = (Id) => ({
  type: actionTypes.DELETE_ROLE,
  Id
});

export const updateRoleStatus = (Id) => ({
  type: actionTypes.UPDATE_ROLE_STATUS,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});

export const getAllPermissions = () => ({
  type: actionTypes.GET_ALL_PERMISSIONS,
});

export const getRoleData = (key) => ({
  type: actionTypes.GET_ROLE_DATA,
  key
});

export const updateRolePermissions = (payload) => ({
  type: actionTypes.UPDATE_ROLE_PERMISSIONS,
  payload
});
